import Head from "next/head";
import { useRouter } from "next/router";
import React, { useEffect } from "react";

import { routes } from "@/utils/routes";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const InfoPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.push(routes.careers);
  }, [router]);

  return (
    <>
      <Head>
        <title>{seoData.INFO_CONNECT_TOOLS.title}</title>
        <SeoMetaData data={seoData.INFO_CONNECT_TOOLS} />
      </Head>
    </>
  );
};

export default InfoPage;
